import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, UserRound } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Field } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [p, setP] = useState({ name: user.name, phone: user.phone || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const saveProfile = async () => {
    try { const { data } = await api.put("/auth/profile", p); setUser(data); toast.success("Profil diperbarui"); } catch (e) { toast.error(errMsg(e)); }
  };
  const changePw = async () => {
    if (pw.new_password !== pw.confirm) return toast.error("Konfirmasi password baru tidak sama");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: pw.current_password, new_password: pw.new_password });
      toast.success("Password berhasil diganti");
      setPw({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Profil Saya" subtitle="Kelola data diri dan password akun Anda." />
      <div className="grid gap-6 lg:grid-cols-2 max-w-5xl">
        <div className="card-premium p-6 fade-up" data-testid="profile-card">
          <h3 className="font-heading text-lg font-semibold mb-4 flex items-center gap-2"><UserRound className="h-5 w-5 text-blue-800" />Data Diri</h3>
          <div className="space-y-4">
            <Field label="Email"><Input value={user.email} disabled className="bg-slate-50" data-testid="profile-email" /></Field>
            <div className="flex items-center gap-2 text-sm"><span className="text-slate-500">Role:</span><Badge variant="outline" className="bg-blue-50 text-blue-800">{user.role}</Badge></div>
            <Field label="Nama"><Input className="bg-white" value={p.name} onChange={(e) => setP({ ...p, name: e.target.value })} data-testid="profile-name-input" /></Field>
            <Field label="No. HP"><Input className="bg-white" value={p.phone} onChange={(e) => setP({ ...p, phone: e.target.value })} data-testid="profile-phone-input" /></Field>
            <Button onClick={saveProfile} data-testid="profile-save-btn">Simpan Profil</Button>
          </div>
        </div>
        <div className="card-premium p-6 fade-up" data-testid="change-password-card">
          <h3 className="font-heading text-lg font-semibold mb-4 flex items-center gap-2"><KeyRound className="h-5 w-5 text-blue-800" />Ganti Password</h3>
          <div className="space-y-4">
            <Field label="Password Lama"><Input type="password" className="bg-white" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="current-password-input" /></Field>
            <Field label="Password Baru (min. 6 karakter)"><Input type="password" className="bg-white" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="new-password-input" /></Field>
            <Field label="Ulangi Password Baru"><Input type="password" className="bg-white" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="confirm-password-input" /></Field>
            <Button onClick={changePw} disabled={busy || !pw.current_password || !pw.new_password} data-testid="change-password-btn">{busy ? "Menyimpan..." : "Ganti Password"}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
